import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { BasePage } from '../../../../shared/components/base-page.component';
import { PasswordHelper } from '../../../../shared/helpers/PasswordHelper';
import { LocalButtonStorageService } from '../../Helpers/LocalButtonStorageHelper';
import { BuilderRegisterApi } from '../Apis/BuilderRegisterApi';
import { BuilderRegisterApiRequest } from '../Apis/Models/BuilderRegisterApiRequest';
import { RegisterPageModel } from './Models/RegisterPageModel';

@Component({
    selector: 'register-page',
    standalone: true,
    imports: [...BasePage.BaseImports],
    templateUrl: './BuilderRegisterPage.html',
    styleUrl: './BuilderRegisterPage.css',
})

export class BuilderRegisterPage implements BasePage, OnInit
{
    model$ = new BehaviorSubject<RegisterPageModel | null>(null);
    error$ = new BehaviorSubject<string | null>(null);
    loading$ = new BehaviorSubject(false);

    constructor(private builderRegisterApi: BuilderRegisterApi, private router: Router)
    {
    }

    async ngOnInit()
    {
        const model = new RegisterPageModel();
        this.model$.next(model);
    }

    async submit(form: NgForm)
    {
        console.log(form.controls);

        if (form.invalid)
        {
            console.log('invalid form');
            form.control.markAllAsTouched(); // show validation errors
            return;
        }

        const stored = LocalButtonStorageService.Get();

        if (!stored)
        {
            alert("Sorry, but we can't find your button in your browser. Please go back and configure it again.");
            return;
        }

        const registerRequest: BuilderRegisterApiRequest = {
            ButtonForegroundColor: stored.ButtonForegroundColor,
            ButtonBackgroundColor: stored.ButtonBackgroundColor,
            ButtonIcon: stored.ButtonIcon,
            Name: this.model$.value!.Name!,
            Domain: this.model$.value!.Domain!,
            FirstName: this.model$.value!.FirstName!,
            LastName: this.model$.value!.LastName!,
            Email: this.model$.value!.Email!,
            Password: this.model$.value!.Password!,
            AcceptTerms: this.model$.value!.AcceptTerms!
        };

        this.loading$.next(true);
        this.error$.next(null);
        try
        {
            await this.builderRegisterApi.PostAsync(registerRequest);

            this.router.navigate(['/account/confirm']);
        }
        catch (err: any)
        {
            this.error$.next(err);
        }
        finally
        {
            this.loading$.next(false);
        }
    }

    validatePassword(password: string | null): string[]
    {
        return PasswordHelper.ValidatePassword(password);
    }
}
